/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ManagedUserBookingCategory } from './ManagedUserBookingCategory';
import type { ManagedUserBookingClient } from './ManagedUserBookingClient';
export type ManagedUserBooking = {
    start: string;
    end: string;
    id: number;
    client: ManagedUserBookingClient;
    category: ManagedUserBookingCategory;
    status: ManagedUserBooking.status;
};
export namespace ManagedUserBooking {
    export enum status {
        OPEN = 'open',
        BOOKED = 'booked',
        ASSIGNED = 'assigned',
        APPROVED = 'approved',
        CANCELLED = 'cancelled',
        REJECTED = 'rejected',
        OUTAGE = 'outage',
        SKIPPED = 'skipped',
        MOVE_REQUESTED = 'move-requested',
    }
}

